module.exports = __webpack_public_path__ + "img/tentPalace.72d0bd0c.svg";